import { FONT_FAMILY } from 'styles/typography'
const themeStyles = colors => {
  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: FONT_FAMILY,
      backgroundColor: colors.lighterSmoke,
      height: '138px',
      fontSize: 14,
      lineHeight: '16px',
      color: colors.secondaryGray
    }
  }
  return styles
}

export default themeStyles
